export const formatValue = value => (`${value}+`)
